import React from 'react';
import PropTypes from 'prop-types';

import MedicalContentTreeItem from '../../_common/MedicalContentTreeItem';

function actionListTypeToLabel(actionType) {
  switch (actionType) {
    case 'elicitSxsAcrossDxhxs':
      return '*Elicit Sxs Across Dxhx';
    case 'doSxActionsAcrossDxhxs':
      return '*Do Actions for All Endorsed Sxs';
    case 'doPtFactorsAcrossDxhxs':
      return '*Do Pt Factor Actions for All Dxhxs';
    case 'doActionsAcrossReportedMeds':
      return '*Do Actions for All Reported Meds';
    case 'setSexMale':
      return '*Set Sex to Male';
    case 'setSexFemale':
      return '*Set Sex to Female';
    case 'anchorMedsSectionInReport':
      return '*Anchor Meds Section In Report';
    default:
      return `*${actionType}`;
  }
}

const actionIsDeletable = (actionType) => actionType === 'anchorMedsSectionInReport';

export default function PlainTextActionTreeItem(props) {
  const {
    actionType,
    setFormPane,
    setTreeManagementServices,
    deleteService,
    raiseService,
    lowerService,
    onSuccess,
  } = props;

  const label = actionListTypeToLabel(actionType);

  const onSelect = () => {
    setFormPane(null);
    setTreeManagementServices({
      onDeleteWarningMessage: 'Are you sure you want to delete this action?',
      deleteService: actionIsDeletable(actionType) ? deleteService : null,
      raiseService,
      lowerService,
      onSuccess,
    });
  };

  return (
    <MedicalContentTreeItem
      id={0}
      MCTreeItemLabel={label}
      isEndNode
      onSelect={onSelect}
    />
  );
}

PlainTextActionTreeItem.propTypes = {
  actionType: PropTypes.oneOf(['addDxHx', 'elicitSxsAcrossDxhxs', 'doSxActionsAcrossDxhxs', 'doPtFactorsAcrossDxhxs', 'doActionsAcrossReportedMeds']).isRequired,
  setFormPane: PropTypes.func.isRequired,
  setTreeManagementServices: PropTypes.func.isRequired,
  deleteService: PropTypes.func,
  raiseService: PropTypes.func,
  lowerService: PropTypes.func,
  onSuccess: PropTypes.func,
};

PlainTextActionTreeItem.defaultProps = {
  deleteService: null,
  raiseService: null,
  lowerService: null,
  onSuccess: () => {},
};
